import React, { useState, useEffect } from "react";
import useTimeSeries from "hooks/useTImeSeries";
import { connectWidget } from "../../widget-connector/WidgetConnector";

const BaseTimeSeriesWidgetRO = (props) => {
  const [timeframe, setTimeframe] = useState(
    props.widget?.options?.timeframe ?? {}
  );

  const { stacks, widget = {}, updateWidget } = props;

  const { startTime, endTime, streams, maxWindowInSeconds, loading } =
    useTimeSeries({
      widget,
      timeframe,
      stacks,
      fixedWindow: props.fixedWindow,
    });

  useEffect(() => {
    // if widget does not specify timeframe, see if there is a default supplied
    // as a property
    const newTimeframe =
      widget.options?.timeframe ?? props.defaultTimeframe ?? {};
    setTimeframe(newTimeframe);
  }, [widget.options?.timeframe, props.defaultTimeframe]);

  return (
    <>
      {props.children({
        widget,
        stacks,
        startTime,
        endTime,
        streams,
        updateWidget,
        setTimeframe,
        timeframe,
        maxWindowInSeconds,
        loading,
        removeWidget: props.removeWidget,
        readOnly: props.readOnly,
      })}
    </>
  );
};

export default connectWidget(BaseTimeSeriesWidgetRO);
